import { Cookies } from 'react-cookie'

export const clientJwtRequestInterceptor =
	(cookieNameJWT, authHeader = 'Authorization') =>
	(config) => {
		const cookies = new Cookies()
		const jwt = cookies.get(cookieNameJWT)

		// Evaluate cookies on every api call
		if (jwt) {
			config.headers[authHeader] = `Bearer ${jwt}`
		} else {
			delete config.headers[authHeader]
		}

		return config
	}
